/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023, 2024.
 */

import { LoginRequestBlock } from '@/components/blocks/LoginRequestBlock';
import {
	headerLoginRegisterPanelMenuCustomSX,
	loginRegisterPanelBoxPaperSX,
	loginRegisterPanelCloseIconXS,
	loginRegisterPanelTitleBoxSX,
	loginRegisterPanelTitleSX,
} from '@/components/content/Header/styles/login/loginRegisterPanel';
import DynamicIcon, { IconName } from '@/components/icons/DynamicIcon';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

type Props = {
	openPanel: boolean;
	setOpenPanel: Dispatch<SetStateAction<boolean>>;
	icon: IconName | '';
	title: string;
	panelText: string;
	classProp?: string;
};

export const LoginRegisterPanel: FC<Props> = ({
	icon,
	title,
	panelText,
	classProp,
	setOpenPanel,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

	return (
		<Stack sx={headerLoginRegisterPanelMenuCustomSX(theme)}>
			<Box sx={loginRegisterPanelTitleBoxSX}>
				{isMobile && icon ? (
					<Box component="span" sx={{ mr: '5px', width: '24px', height: '24px' }}>
						<DynamicIcon name={icon} variant="filled" color={theme.palette.primary.main} />
					</Box>
				) : null}
				<Typography
					variant="body1"
					component={'span'}
					fontWeight={OpenSansFontWeights.light}
					sx={loginRegisterPanelTitleSX}
				>
					{title}
				</Typography>
				{isMobile ? (
					<CloseIcon
						onClick={() => setOpenPanel(false)}
						sx={loginRegisterPanelCloseIconXS}
						className={`${classProp}__close`}
					/>
				) : null}
			</Box>
			<Divider />
			<Box sx={loginRegisterPanelBoxPaperSX}>
				<LoginRequestBlock panelText={panelText} classProp={classProp} />
			</Box>
		</Stack>
	);
};
